import { generateMessage } from './generate-message.effects';
import { runTools } from './tools.effects';

export default [generateMessage, runTools];
